import Seb from '@/shared/application/seb'
import router from '@/router'
import { AxiosRequestConfig, CancelToken } from 'axios'
import i18n from '@/plugins/vue-i18n'
import axios from '@/plugins/axios'
import { IRestResponseDto } from '@/shared/models/shared/rest-response-dto'

export default class SebService {
  private static async request<T> (request: AxiosRequestConfig, loadingEnabled = true): Promise<IRestResponseDto<T>> {
    let isBadRequest = false

    if (loadingEnabled) {
      Seb.isLoading = true
    }

    let content: any
    let isCanceled = false
    try {
      const response = await axios.request<T | string>(request)
      if (response) {
        if (response.status === 401) {
          router.push({ path: '/disconnect' })
        }

        if (response.status !== 200 && response.status !== 204) {
          isBadRequest = true
        }

        try {
          content = JSON.parse(response.data as string)
        } catch (err) {
          content = response.data
        }
      }
    } catch (error: any) {
      if (error.message && (error.message as string).split('-')[0] === 'cancel') {
        isBadRequest = false
        isCanceled = true
        content = {} as T
      } else if (error.isAxiosError && error.code === 'ECONNABORTED') {
        isBadRequest = true
        content = i18n.t('Server.tooLong').toString()
      } else {
        content = i18n.t('Flows.Error').toString()
        isBadRequest = true
      }
    }

    const result = {
      isCanceled,
      isError: isBadRequest,
      errors: isBadRequest ? content : null,
      content: isBadRequest ? null : content
    } as IRestResponseDto<T>

    Seb.isLoading = false

    return result
  }

  public get<T> (url: string, loadingEnabled = true, header: { [key: string]: string } = {}, cancelToken: CancelToken | undefined = undefined): Promise<IRestResponseDto<T>> {
    const request: AxiosRequestConfig = {
      url,
      method: 'GET',
      headers: header,
      cancelToken,
      timeout: 15000 // 15 seconds
    }
    return SebService.request<T>(request, loadingEnabled)
  }

  public delete (url: string): Promise<IRestResponseDto<void>> {
    const request: AxiosRequestConfig = {
      url,
      method: 'DELETE'
    }
    return SebService.request<void>(request)
  }

  public put<T> (url: string, data: object | string): Promise<IRestResponseDto<T>> {
    const request: AxiosRequestConfig = {
      url,
      method: 'PUT',
      data
    }
    return SebService.request<T>(request)
  }

  public post<T> (url: string, data: object | string): Promise<IRestResponseDto<T>> {
    const request: AxiosRequestConfig = {
      url,
      method: 'POST',
      data
    }
    return SebService.request<T>(request)
  }
}
